import React from 'react'
import { useAtomValue } from 'jotai'
import { categoriesAtom, allVisiblePictogramsAtom } from 'atoms'
import { Grid, Box } from '@mui/material'
import PictogramCard from 'components/PictogramsViewer/PictogramCard'
import { pictograms as pictoData } from 'components/SearchField/pictograms'
import { pictoSizeAtom, textSettingsAtom } from 'atoms'

const BoardViewer = () => {
  const categories = useAtomValue(categoriesAtom)
  const pictograms = useAtomValue(allVisiblePictogramsAtom)

  const pictogramsByCategory = categories.reduce((acc, category) => {
    acc[category] = pictograms.filter((p) => p.category === category)
    return acc
  }, {})

  // Filter out pictograms that are not in the keywords list
  // for (const category in pictogramsByCategory) {
  //   pictogramsByCategory[category] = pictogramsByCategory[category].filter(
  //     (pictogram) =>
  //       Object.keys(pictoData).includes(pictogram.source.toLowerCase())
  //   )
  // }

  // Retrieve settings for size and text
  const pictoSize = useAtomValue(pictoSizeAtom)
  const textSettings = useAtomValue(textSettingsAtom)
  const { fontSize } = textSettings

  // Calculate item size
  const gridItemWidth = pictoSize + 8 // Reduced margin
  const gridItemHeight = pictoSize + 4 * fontSize + 8

  return (
    <Box sx={{ overflowX: 'auto', padding: 2 }}>
      {/* Render Rows of Pictograms */}
      {Array.from({
        length: Math.max(
          ...Object.values(pictogramsByCategory).map((arr) => arr.length)
        ),
      }).map((_, rowIndex) => (
        <Grid
          container
          key={rowIndex}
          sx={{
            display: 'grid',
            gridTemplateColumns: `repeat(${categories.length}, ${gridItemWidth}px)`, // Ensure equal column width
            gridAutoRows: `${gridItemHeight}px`, // Set row height based on calculated size
            justifyContent: 'center', // Centers the row content
            marginLeft: 'auto',
            gapRow: 0,
            marginRight: 'auto',
          }}
        >
          {categories.map((category) => (
            <Grid
              item
              key={`${rowIndex}-${category}`}
              sx={{
                display: 'flex', // Ensures items align properly
                justifyContent: 'center', // Centers cards within their columns
                marginBottom: '8px',
              }}
            >
              {pictogramsByCategory[category][rowIndex] && (
                <PictogramCard
                  uuid={pictogramsByCategory[category][rowIndex].uuid}
                />
              )}
            </Grid>
          ))}
        </Grid>
      ))}
    </Box>
  )
}

export default BoardViewer
